import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Alta velocidade transacional",
    correct: false,
  },
  {
    option: "b) Um datalake corporativo altamente eficiente",
    correct: false,
  },
  {
    option: "c) Compatível com SQL e NoSQL",
    correct: false,
  },
  {
    option:
      "d) Extrema eficiência no armazenamento de grandes volumes devido a extrema compactação de dados",
    correct: true,
  },
  {
    option: "e) Facilidade de implementar governança de dados",
    correct: false,
  },
];

export default function Question29(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question29: {
          title: "Qual o maior diferencial do DORA?",
          option: option.option,
          correct: option.correct,
          order: 29
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t("Qual o maior diferencial do DORA?")}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
